import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { finalize } from "rxjs/operators";
// Custom packages
import { AccessLogsService } from "src/app/modules/access-logs/access-logs.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { Property } from "src/app/shared/models/property/property.model";
import { ConfigService } from "src/app/shared/services/config.service";
import { FireSafetyDocsService } from "src/app/shared/services/fire-safety-docs.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { PrivacyStudioDocsService } from "src/app/shared/services/privacy-studio-docs.service";
import { VideoViewService } from "src/app/shared/services/video-view.service";
import { GenericDocsService } from "../../modules/generic-docs/generic-docs.service";
import { DocumentDownloadDialogComponent } from "../../modules/properties/components/document-download-dialog/document-download-dialog.component";
import { CondoStructuresService } from "../../modules/properties/condo-structures.service";
import { DocumentArchivesService } from "../../modules/properties/document-archives.service";
import DocumentTypeStructure from "../../modules/properties/documentTypes";
var PublicQRCodeComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PublicQRCodeComponent(dialog, helperService, activatedRoute, translateService, propertiesService, configService, accessLogsService, condoStructuresService, documentArchivesService, toastrService, settingsService, genericDocsService, videoViewService, fireSafetyDocsService, companiesService, privacyStudioDocsService) {
        this.dialog = dialog;
        this.helperService = helperService;
        this.activatedRoute = activatedRoute;
        this.translateService = translateService;
        this.propertiesService = propertiesService;
        this.configService = configService;
        this.accessLogsService = accessLogsService;
        this.condoStructuresService = condoStructuresService;
        this.documentArchivesService = documentArchivesService;
        this.toastrService = toastrService;
        this.settingsService = settingsService;
        this.genericDocsService = genericDocsService;
        this.videoViewService = videoViewService;
        this.fireSafetyDocsService = fireSafetyDocsService;
        this.companiesService = companiesService;
        this.privacyStudioDocsService = privacyStudioDocsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.property = new Property();
        // BEGIN - Add property form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("qrcode.viewPage.form.submitButtonText"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-sign-in",
                inline: true,
            },
        };
        // END - Add property form
        this.pageIsLoaded = false;
        this.formUserData = false;
        this.propertyId = "";
        this.documentId = "";
        this.isFireSafetyDoc = false;
        this.isGenericDoc = false;
        this.isPrivacyStudioDoc = false;
        this.isVideo = false;
        this.isVideoOld = false;
        this.isSafetyVideoSuppliers = false;
        this.isSafetyVideoResidents = false;
        this.isDoc = false;
        this.isDocsSection = false;
        this.isDocsSectionOld = false;
        this.showVideo = false;
        this.showVideoResident = false;
        this.showVideoSupplier = false;
        this.showDoc = false;
        this.showDocSection = false;
        this.allDocs = [];
        this.displayedDocs = [];
        this.sortActive = false;
        this.companyId = "";
        // query string section QR code from App
        this.firstName = "";
        this.lastName = "";
        this.companyName = "";
        this.forceSubmit = false;
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.insertedDocs = [];
        this.documentTypeStructure = new DocumentTypeStructure();
        this.showMasterVideoResident = false;
        this.mastersVideoResident = [
            '63592efd6a8bbf24104c0e16',
            '666ad1b2ee17cc075eff0301'
        ];
        this.originalOrder = function (a, b) {
            return 0;
        };
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    PublicQRCodeComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Subscribe to current lang and init component
        this.translateService.use("it");
        // Video da piattaforma 1
        // /qrcode/600e2164-861f-11e6-849f-000c29dd368f/videoext
        // Singolo documento generico, quindi senza la struttura
        // /qrcode/5f8d4975a2a02e1a9488b898/gest-amm-tivo-gestionali/generic/AC2/5ffdcece2c5484787558f187
        // 5f8d4975a2a02e1a9488b898 = id archviodocumenti
        // 5fd499c20ad99956dc4629e0 = id del subdocument
        // Singolo documento legato a un struttura
        // /qrcode/5f7dcdbf2489c53ab08bad07/gest-amm-tivo-dipendenti/5fd499c30ad99956dc4629f0/AA1/5fd499c30ad99956dc4629f1
        // 5f7dcdbf2489c53ab08bad07 = id archviodocumenti
        // 5fd499c30ad99956dc4629f0 = id document
        // 5fd499c30ad99956dc4629f1 = id del subdocument
        // Area archivio
        // /qrcode/5f7dcdbf2489c53ab08bad07/docstructure/gestionaleAmministrativo
        // 5f7dcdbf2489c53ab08bad07 = id archviodocumenti
        // Area sub archivio
        // /qrcode/5f8d4d7b59ef783bdc11fea2/docsubstructure/gestionaleAmministrativo/gestAmmTivoSicurezza
        // 5f8d4d7b59ef783bdc11fea2 = id archviodocumenti
        // Area sub archivio and only one structure
        // /qrcode/5f8d4975a2a02e1a9488b898/docsubstructure/ascensoriEMontauto/ascensoriEMontautoAscensori/5fb4dbc1b1d85e7478c33abc
        // 5f8d4975a2a02e1a9488b898 = id archviodocumenti
        // Area archivio piattaforma 1
        // https://app.archedi.it/buildings/showDocs/f4a0c2b4-dd08-11e8-a685-000c29dd368f/104/5bfd7f7b-2c7c-46af-9c2d-781ec0a8506a/
        // f4a0c2b4-dd08-11e8-a685-000c29dd368f = idold property
        // 104 = categoria documento => Impianto elettrico generale
        if (this.activatedRoute.snapshot.url &&
            this.activatedRoute.snapshot.url.length > 2) {
            var query = this.activatedRoute.snapshot.queryParams;
            switch (this.activatedRoute.snapshot.url[2].path) {
                case "fireSafetyDoc":
                    this.isFireSafetyDoc = true;
                    this.formUserData = false;
                    break;
                case "genericDoc":
                    this.isGenericDoc = true;
                    this.formUserData = false;
                    break;
                case "privacyStudioDoc":
                    this.isPrivacyStudioDoc = true;
                    this.formUserData = false;
                    break;
                case "video":
                    this.isVideo = true;
                    if (query) {
                        this.firstName = query.firstName ? query.firstName : "";
                        this.lastName = query.lastName ? query.lastName : "";
                        this.companyName = query.companyName ? query.companyName : "";
                        if (this.firstName && this.lastName && this.companyName) {
                            this.forceSubmit = true;
                        }
                    }
                    break;
                case "videoext":
                    this.isVideo = true;
                    this.isVideoOld = true;
                    break;
                case "safetyVideoSuppliers":
                    this.isSafetyVideoSuppliers = true;
                    break;
                case "safetyVideoResidents":
                    this.isSafetyVideoResidents = true;
                    break;
                case "docstructure":
                    this.isDocsSection = true;
                    if (query) {
                        this.firstName = query.firstName ? query.firstName : "";
                        this.lastName = query.lastName ? query.lastName : "";
                        this.companyName = query.companyName ? query.companyName : "";
                        if (this.firstName && this.lastName && this.companyName) {
                            this.forceSubmit = true;
                        }
                    }
                    break;
                case "docsubstructure":
                    this.isDocsSection = true;
                    if (query) {
                        this.firstName = query.firstName ? query.firstName : "";
                        this.lastName = query.lastName ? query.lastName : "";
                        this.companyName = query.companyName ? query.companyName : "";
                        if (this.firstName && this.lastName && this.companyName) {
                            this.forceSubmit = true;
                        }
                    }
                    break;
                case "docstructureext":
                    this.isDocsSection = true;
                    this.isDocsSectionOld = true;
                    break;
                default:
                    this.isDoc = true;
                    break;
            }
        }
        if (this.isFireSafetyDoc) {
            var documentId = this.activatedRoute.snapshot.params.documentId;
            this.subscriptions.push(this.fireSafetyDocsService.getDocByView(documentId).subscribe(function (res) {
                if (res.status) {
                    _this.fireSafetyDoc = res.data;
                }
            }));
        }
        if (this.isGenericDoc) {
            var documentId = this.activatedRoute.snapshot.params.documentId;
            this.subscriptions.push(this.genericDocsService.getDocByView(documentId).subscribe(function (res) {
                if (res.status) {
                    _this.genericDoc = res.data;
                }
            }));
        }
        if (this.isPrivacyStudioDoc) {
            var documentId = this.activatedRoute.snapshot.params.documentId;
            this.subscriptions.push(this.privacyStudioDocsService.getDocByView(documentId).subscribe(function (res) {
                if (res.status) {
                    _this.privacyStudioDoc = res.data;
                }
            }));
        }
        if (this.isVideo) {
            var propertyId = this.activatedRoute.snapshot.params.propertyId;
            if (this.isVideoOld) {
                // Get property from old Id
                this.subscriptions.push(this.propertiesService.getByOldId(propertyId).subscribe(function (res) {
                    if (res.status) {
                        if (res.propertyId) {
                            _this.propertyId = res.propertyId;
                            _this.formUserData = true;
                            _this.initForm();
                        }
                    }
                }));
            }
            else {
                this.propertyId = propertyId;
                // const { t } = this.activatedRoute.snapshot.queryParams;
                // if (t) {
                //   // check token validation
                //   this.subscriptions.push(
                //     this.propertiesService
                //       .getVideoVisitByToken(this.propertyId, t)
                //       .subscribe((res) => {
                //         if (res.status) {
                //           if (res.item && Array.isArray(res.item) && res.item.length) {
                //             if (res.item[0].createdAt) {
                //               const today = moment();
                //               const createdAt = moment(res.item[0].createdAt);
                //               if (today.diff(createdAt, "hours") > 8) {
                //                 this.formUserData = true;
                //                 this.initForm();
                //               } else {
                //                 this.showVideo = true;
                //               }
                //             } else {
                //               this.formUserData = true;
                //               this.initForm();
                //             }
                //           } else {
                //             this.formUserData = true;
                //             this.initForm();
                //           }
                //         } else {
                //           this.formUserData = true;
                //           this.initForm();
                //         }
                //       })
                //   );
                // } else {
                //   this.formUserData = true;
                //   this.initForm();
                // }
                this.formUserData = true;
                this.initForm();
            }
        }
        if (this.isSafetyVideoSuppliers || this.isSafetyVideoResidents) {
            var companyId = this.activatedRoute.snapshot.params.companyId;
            this.companyId = companyId;
            // Scanning the QR must show the video right away: skip the user-data form
            // and do not track the view (no firstName/lastName/companyName collected).
            this.formUserData = false;
            if (this.isSafetyVideoResidents) {
                this.showVideoResident = true;
            }
            else {
                this.showVideoSupplier = true;
            }
            if (this.isSafetyVideoResidents &&
                this.mastersVideoResident.includes(this.companyId)) {
                // Master residents keep showing the company name + ANACI badge above the video.
                this.showMasterVideoResident = true;
                this.subscriptions.push(this.companiesService
                    .getBaseData(this.companyId)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.master = res.data.name;
                    }
                }));
            }
        }
        if (this.isDocsSection) {
            if (this.isDocsSectionOld) {
                var _a = this.activatedRoute.snapshot.params, propertyId = _a.propertyId, sectionold = _a.sectionold;
                //  gestionaleAmministrativo
                //  catasto
                //  urbanisticaEdEdilizia
                //  reportistica
                //  stackingPlan
                //  lineaVita
                //  amiantoDoc
                //  edile
                //  impiantoElettrico
                //  riscaldamentoCondizionamento
                //  ascensoriEMontauto
                //  trattamentoAcqua
                //  impiantiElettronici
                //  attivitaSottopostePrevenzioneIncendi
                //  impiantiAntincendio
                //  impiantiSpeciali
                //  impiantiRicreativiSportivi
                //  unitaImmobiliari
                var section_1 = "gestionaleAmministrativo";
                switch (sectionold) {
                    case "1":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Riscaldamento centralizzato"
                    case "3":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Bruciatori"
                    case "4":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Serbatoio gasolio"
                    case "5":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Gas metano - contatori e rete"
                    case "6":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Sottostazioni riscaldamento"
                    case "7":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Canne fumarie ad uso esclusivo centrale termica"
                    case "8":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Impianti per la produzione acqua calda sanitari da solare termico"
                    case "9":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Centrale di ricevimento da teleriscaldamento	"
                    case "10":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Riscaldamento con sonde geotermiche e pompe di calore"
                    case "11":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Riscaldamento con sole pompe di calore"
                    case "12":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Centrale di ricevimento riscaldamento da altro condominio/BSC"
                    case "13":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Centrale di ricevimento riscaldamento da supercondominio"
                    case "14":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Impianto di condizionamento"
                    case "15":
                        section_1 = "trattamentoAcqua";
                        break; // "Centrale idrica"
                    case "16":
                        section_1 = "trattamentoAcqua";
                        break; // "Sottostazione idrica alimentata da altro condominio"
                    case "17":
                        section_1 = "trattamentoAcqua";
                        break; // "Sottostazione idrica alimentata da BSC"
                    case "18":
                        section_1 = "trattamentoAcqua";
                        break; // "Pompe sollevamento acque piovane/nere"
                    case "19":
                        section_1 = "trattamentoAcqua";
                        break; // "Pompe sollevamento acque nere"
                    case "20":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Dipendenti"
                    case "21":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Gestione dipendenti"
                    case "22":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Gestionali"
                    case "23":
                        section_1 = "impiantoElettrico";
                        break; // "Potenza totale impegnata per l'impianto elettrico alimentato in BT/MT 230/400V inferiore o uguale a 6KW"
                    case "24":
                        section_1 = "impiantoElettrico";
                        break; // "Potenza totale impegnata per l'impianto elettrico alimentato in BT/MT 230/400V superiore a 6KW"
                    case "25":
                        section_1 = "impiantoElettrico";
                        break; // "Impianto elettrico alimentato da propria cabina in media tensione"
                    case "26":
                        section_1 = "impiantoElettrico";
                        break; // "Impianto fotovoltaico inferiore o uguale a 20KW"
                    case "27":
                        section_1 = "impiantoElettrico";
                        break; // "Impianto Fotovoltaico > 20KW"
                    case "28":
                        section_1 = "impiantoElettrico";
                        break; // "Gruppo elettrogeno"
                    case "29":
                        section_1 = "impiantoElettrico";
                        break; // "Impianto di protezione delle scariche atmosferiche"
                    case "30":
                        section_1 = "ascensoriEMontauto";
                        break; // "Ascensori"
                    case "31":
                        section_1 = "ascensoriEMontauto";
                        break; // "Montauto"
                    case "32":
                        section_1 = "impiantiElettronici";
                        break; // "Impianto centralizzato TV terrestre"
                    case "33":
                        section_1 = "impiantiElettronici";
                        break; // "Impianto centralizzato TV satellitare"
                    case "34":
                        section_1 = "impiantiElettronici";
                        break; // "Impianto citofonico/video"
                    case "35":
                        section_1 = "impiantiElettronici";
                        break; // "Impianto TVCC"
                    case "36":
                        section_1 = "impiantiElettronici";
                        break; // "Impianto automazione cancelli e simili"
                    case "37":
                        section_1 = "impiantiElettronici";
                        break; // "Impianto antintrusione"
                    case "38":
                        section_1 = "impiantoElettrico";
                        break; // "Impianto elettrico "
                    case "39":
                        section_1 = "impiantiElettronici";
                        break; // "Impianto antintrusione"
                    case "40":
                        section_1 = "trattamentoAcqua";
                        break; // "Impianti idrico/sanitari"
                    case "41":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Impianti termici"
                    case "42":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Impianti di condizionamento"
                    case "43":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Ape - Prestazione energetica"
                    case "44":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Elaborati grafici"
                    case "45":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Canne fumarie singola unità immobiliare"
                    case "46":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Amianto fabbricati"
                    case "47":
                        section_1 = "gestionaleAmministrativo";
                        break; // "APE - attestato di prestazione energetica"
                    case "48":
                        section_1 = "lineaVita";
                        break; // "Linea vita"
                    case "49":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Documenti di costruzione dell'edificio/i"
                    case "50":
                        section_1 = "edile";
                        break; // "Compartimentazione REI murature"
                    case "51":
                        section_1 = "edile";
                        break; // "Porte REI"
                    case "52":
                        section_1 = "edile";
                        break; // "Interventi successivi alla costruzione dell'edificio"
                    case "53":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Eleborati grafici/planimetrie"
                    case "54":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Canne fumarie collettive ramificate"
                    case "55":
                        section_1 = "impiantiRicreativiSportivi";
                        break; // "Piscina"
                    case "56":
                        section_1 = "impiantiRicreativiSportivi";
                        break; // "Palestra"
                    case "57":
                        section_1 = "impiantiRicreativiSportivi";
                        break; // "Campo da tennis"
                    case "58":
                        section_1 = "impiantiRicreativiSportivi";
                        break; // "Campo da calcio/calcetto"
                    case "59":
                        section_1 = "impiantiRicreativiSportivi";
                        break; // "Parco giochi"
                    case "60":
                        section_1 = "impiantiAntincendio";
                        break; // "Estintori"
                    case "61":
                        section_1 = "impiantiAntincendio";
                        break; // "Rete idranti"
                    case "62":
                        section_1 = "impiantiAntincendio";
                        break; // "Rete sprinkler"
                    case "63":
                        section_1 = "impiantiAntincendio";
                        break; // "Stazione di pompaggio per rete antincendio"
                    case "64":
                        section_1 = "impiantiAntincendio";
                        break; // "Rilevazione fumo/incendio e/o CO e/o benzene e/o miscele esplosive"
                    case "65":
                        section_1 = "impiantiAntincendio";
                        break; // "Rilevazione fumo/incendio e/o CO e/o benzene e/o miscele esplosive"
                    case "66":
                        section_1 = "impiantiAntincendio";
                        break; // "Rilevazione fumo/incendio e/o CO e/o benzene e/o miscele esplosive"
                    case "67":
                        section_1 = "impiantiAntincendio";
                        break; // "Ventilazione meccanica per estrazione"
                    case "68":
                        section_1 = "impiantiAntincendio";
                        break; // "Ventilazione meccanica per immissione"
                    case "69":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "VVF Vecchio Regolamento"
                    case "70":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "VV.F. NUOVO REGOLAMENTO Att. 49-74-75-77 "
                    case "71":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "VV.F. NUOVO REGOLAMENTO Att. 49-74-75-77 Cat. ""B"""
                    case "72":
                        section_1 = "v";
                        break; // "VV.F. NUOVO REGOLAMENTO Att. 49-74-75-77 Cat. ""C"""
                    case "73":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Banca"
                    case "74":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Cause legali / Accertamenti e contenziosi"
                    case "75":
                        section_1 = "amiantoDoc";
                        break; // "Amianto scale"
                    case "76":
                        section_1 = "amiantoDoc";
                        break; // "Amianto box"
                    case "77":
                        section_1 = "amiantoDoc";
                        break; // "Amianto giardini"
                    case "78":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "V.V.F. NUOVO REGOLAMENTO"
                    case "80":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Contratti forniture e servizi"
                    case "81":
                        section_1 = "amiantoDoc";
                        break; // "Amianto"
                    case "83":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 49 Cat. ""A"""
                    case "84":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 74 Cat. ""A"""
                    case "85":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 75 Cat. ""A"""
                    case "87":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 77 Cat. ""A"""
                    case "88":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 49 Cat. ""B"""
                    case "89":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // " Att. 74 Cat. ""B"""
                    case "90":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 75 Cat. ""B"""
                    case "92":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 77 Cat. ""B"""
                    case "93":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 49 Cat. ""C"""
                    case "94":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 74 Cat. ""C"""
                    case "95":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Att. 75 Cat. ""C"""
                    case "96":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "VVF Nuovo Regolamento"
                    case "98":
                        section_1 = "impiantiAntincendio";
                        break; // "Rete Sprinkler Box"
                    case "99":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Dipendenti/annuali"
                    case "100":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Gestione dipendenti/ annuali"
                    case "101":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Gestionali annuali"
                    case "103":
                        section_1 = "unitaImmobiliari";
                        break; // "Unita abitative e Commerciali"
                    case "104":
                        section_1 = "impiantoElettrico";
                        break; // "Impianto elettrico generale"
                    case "106":
                        section_1 = "trattamentoAcqua";
                        break; // "Rete idrica sanitaria"
                    case "107":
                        section_1 = "impiantiSpeciali";
                        break; // "Impianto supplementare"
                    case "108":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Atto di acquisto/vendita/provenienza"
                    case "109":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Vincoli e diritti"
                    case "111":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Ipoteche"
                    case "112":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Titolarietà"
                    case "113":
                        section_1 = "catasto";
                        break; // "Catasto terreni"
                    case "114":
                        section_1 = "catasto";
                        break; // "Catasto fabbricati"
                    case "115":
                        section_1 = "urbanisticaEdEdilizia";
                        break; // "Urbanistica ed edilizia"
                    case "116":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Condoni"
                    case "117":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Autorizzazioni"
                    case "118":
                        section_1 = "edile";
                        break; // "Strutture"
                    case "119":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Contratti di locazione"
                    case "120":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Sicurezza"
                    case "121":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Assicurazioni"
                    case "122":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Documenti amministrativi"
                    case "123":
                        section_1 = "reportistica";
                        break; // "Reportistica"
                    case "124":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Sicurezza"
                    case "125":
                        section_1 = "riscaldamentoCondizionamento";
                        break; // "Serbatoio a gasolio dismesso"
                    case "126":
                        section_1 = "trattamentoAcqua";
                        break; // "Contatore acqua"
                    case "127":
                        section_1 = "stackingPlan";
                        break; // "Stacking Plan"
                    case "128":
                        section_1 = "gestionaleAmministrativo";
                        break; // "Valutazione fornitori"
                    case "129":
                        section_1 = "attivitaSottopostePrevenzioneIncendi";
                        break; // "Attività sottoposte ai controlli prevenzione incendi"
                    case "130":
                        section_1 = "edile";
                        break; // "Rete fognaria"
                }
                // Get property from old Id
                this.subscriptions.push(this.propertiesService.getByOldId(propertyId).subscribe(function (res) {
                    if (res.status) {
                        if (res.propertyId) {
                            _this.propertyId = res.propertyId;
                            _this.documentId = res.documentArchiveId;
                            _this.formUserData = true;
                            _this.subscriptions.push(_this.documentArchivesService
                                .getQrcode(_this.documentId)
                                .subscribe(function (res) {
                                if (res.status) {
                                    _this.documentArchive = res.data;
                                    _this.condoStructuresService
                                        .getQrcode(res.data.structureId)
                                        .subscribe(function (res) {
                                        if (res.status) {
                                            _this.condoStructure = res.data;
                                            _this.companyId = res.data.companyId;
                                            _this.subscriptions.push(_this.settingsService.getDocument().subscribe(function (res) {
                                                if (res.status) {
                                                    if (res.data &&
                                                        Array.isArray(res.data) &&
                                                        res.data.length > 0 &&
                                                        res.data[0].area &&
                                                        Array.isArray(res.data[0].area)) {
                                                        _this.documentTemplateId = res.data[0]._id;
                                                        _this.documentTemplate = res.data[0].area;
                                                        _this.allDocs = _this.documentTypeStructure.getDocumentArchiveData("it", // this.lang, 
                                                        _this.documentTemplate, _this.condoStructure, _this.documentArchive, "FULL", // this.subscriptionType,
                                                        _this.insertedDocs);
                                                        _this.formUserData = true;
                                                        _this.initForm();
                                                        _this.displayedDocs = _this.allDocs.filter(function (docs) {
                                                            var e_1, _a, e_2, _b;
                                                            var title = docs.keyTranslateTitle.replace("properties.documents.", "");
                                                            // filter missing docs and deleted structure
                                                            if (title === section_1) {
                                                                var contents = docs.content;
                                                                if (contents && Array.isArray(contents)) {
                                                                    try {
                                                                        for (var contents_1 = tslib_1.__values(contents), contents_1_1 = contents_1.next(); !contents_1_1.done; contents_1_1 = contents_1.next()) {
                                                                            var item = contents_1_1.value;
                                                                            var subContents = item.content;
                                                                            var displaySubContents = [];
                                                                            if (subContents && Array.isArray(subContents)) {
                                                                                try {
                                                                                    for (var subContents_1 = (e_2 = void 0, tslib_1.__values(subContents)), subContents_1_1 = subContents_1.next(); !subContents_1_1.done; subContents_1_1 = subContents_1.next()) {
                                                                                        var subItem = subContents_1_1.value;
                                                                                        if (subItem.structureId && subItem.structureId !== "") {
                                                                                            if (subItem.active) {
                                                                                                var subSubContent = subItem.content;
                                                                                                if (subSubContent && Array.isArray(subSubContent)) {
                                                                                                    subSubContent = subSubContent.filter(function (subSubItem) {
                                                                                                        return !subSubItem.deleted &&
                                                                                                            // !subSubItem.contract &&
                                                                                                            !subSubItem.expired &&
                                                                                                            subSubItem.data &&
                                                                                                            subSubItem.data.document &&
                                                                                                            Array.isArray(subSubItem.data.document) &&
                                                                                                            subSubItem.data.document.length > 0;
                                                                                                    });
                                                                                                }
                                                                                                if (subSubContent.length > 0) {
                                                                                                    subItem.content = subSubContent;
                                                                                                    displaySubContents.push(subItem);
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        else if (subItem.type === "title" && subItem.content && Array.isArray(subItem.content)) {
                                                                                            var subSubContent = subItem.content.filter(function (subSubItem) {
                                                                                                return !subSubItem.deleted &&
                                                                                                    !subSubItem.expired &&
                                                                                                    subSubItem.data &&
                                                                                                    subSubItem.data.document &&
                                                                                                    Array.isArray(subSubItem.data.document) &&
                                                                                                    subSubItem.data.document.length > 0;
                                                                                            });
                                                                                            if (subSubContent.length > 0) {
                                                                                                subItem.content = subSubContent;
                                                                                                displaySubContents.push(subItem);
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            if (!subItem.deleted &&
                                                                                                // !subItem.contract &&
                                                                                                !subItem.expired &&
                                                                                                subItem.data &&
                                                                                                subItem.data.document &&
                                                                                                Array.isArray(subItem.data.document) &&
                                                                                                subItem.data.document.length > 0) {
                                                                                                displaySubContents.push(subItem);
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                                                                finally {
                                                                                    try {
                                                                                        if (subContents_1_1 && !subContents_1_1.done && (_b = subContents_1.return)) _b.call(subContents_1);
                                                                                    }
                                                                                    finally { if (e_2) throw e_2.error; }
                                                                                }
                                                                            }
                                                                            item.content = displaySubContents;
                                                                        }
                                                                    }
                                                                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                                                    finally {
                                                                        try {
                                                                            if (contents_1_1 && !contents_1_1.done && (_a = contents_1.return)) _a.call(contents_1);
                                                                        }
                                                                        finally { if (e_1) throw e_1.error; }
                                                                    }
                                                                }
                                                                // filter empty first level docs
                                                                docs.content = docs.content.filter(function (doc) {
                                                                    return doc.content && doc.content.length > 0;
                                                                });
                                                            }
                                                            return title === section_1;
                                                        });
                                                    }
                                                }
                                            }, function (err) {
                                                //
                                            }));
                                        }
                                    });
                                }
                                else {
                                    _this.toastrService.error(res.message);
                                }
                            }, function (err) {
                                // if we came here users with given userId do not exist
                            }));
                        }
                    }
                }));
            }
            else {
                var _b = this.activatedRoute.snapshot.params, documentId = _b.documentId, section_2 = _b.section, subSection = _b.subSection, structureId = _b.structureId;
                this.documentId = documentId;
                this.subscriptions.push(this.documentArchivesService.getQrcode(this.documentId).subscribe(function (res) {
                    if (res.status) {
                        _this.documentArchive = res.data;
                        _this.propertyId = res.data.property;
                        _this.condoStructuresService
                            .getQrcode(res.data.structureId)
                            .subscribe(function (res) {
                            if (res.status) {
                                _this.condoStructure = res.data;
                                _this.companyId = res.data.companyId;
                                _this.subscriptions.push(_this.settingsService.getDocument().subscribe(function (res) {
                                    if (res.status) {
                                        if (res.data &&
                                            Array.isArray(res.data) &&
                                            res.data.length > 0 &&
                                            res.data[0].area &&
                                            Array.isArray(res.data[0].area)) {
                                            _this.documentTemplateId = res.data[0]._id;
                                            _this.documentTemplate = res.data[0].area;
                                            _this.allDocs = _this.documentTypeStructure.getDocumentArchiveData("it", // this.lang, 
                                            _this.documentTemplate, _this.condoStructure, _this.documentArchive, "FULL", // this.subscriptionType,
                                            _this.insertedDocs);
                                            _this.formUserData = true;
                                            _this.initForm();
                                            _this.displayedDocs = _this.allDocs.filter(function (docs) {
                                                var e_3, _a, e_4, _b;
                                                var title = docs.keyTranslateTitle.replace("properties.documents.", "");
                                                // filter missing docs and deleted structure
                                                if (title === section_2) {
                                                    var contents = docs.content;
                                                    if (contents && Array.isArray(contents)) {
                                                        try {
                                                            for (var contents_2 = tslib_1.__values(contents), contents_2_1 = contents_2.next(); !contents_2_1.done; contents_2_1 = contents_2.next()) {
                                                                var item = contents_2_1.value;
                                                                var subContents = item.content;
                                                                var displaySubContents = [];
                                                                if (subContents && Array.isArray(subContents)) {
                                                                    try {
                                                                        for (var subContents_2 = (e_4 = void 0, tslib_1.__values(subContents)), subContents_2_1 = subContents_2.next(); !subContents_2_1.done; subContents_2_1 = subContents_2.next()) {
                                                                            var subItem = subContents_2_1.value;
                                                                            if (subItem.structureId && subItem.structureId !== "") {
                                                                                if (subItem.active) {
                                                                                    var subSubContent = subItem.content;
                                                                                    if (subSubContent && Array.isArray(subSubContent)) {
                                                                                        subSubContent = subSubContent.filter(function (subSubItem) {
                                                                                            return !subSubItem.deleted &&
                                                                                                // !subSubItem.contract &&
                                                                                                !subSubItem.expired &&
                                                                                                subSubItem.data &&
                                                                                                subSubItem.data.document &&
                                                                                                Array.isArray(subSubItem.data.document) &&
                                                                                                subSubItem.data.document.length > 0;
                                                                                        });
                                                                                    }
                                                                                    if (subSubContent.length > 0) {
                                                                                        subItem.content = subSubContent;
                                                                                        displaySubContents.push(subItem);
                                                                                    }
                                                                                }
                                                                            }
                                                                            else if (subItem.type === "title" && subItem.content && Array.isArray(subItem.content)) {
                                                                                var subSubContent = subItem.content.filter(function (subSubItem) {
                                                                                    return !subSubItem.deleted &&
                                                                                        !subSubItem.expired &&
                                                                                        subSubItem.data &&
                                                                                        subSubItem.data.document &&
                                                                                        Array.isArray(subSubItem.data.document) &&
                                                                                        subSubItem.data.document.length > 0;
                                                                                });
                                                                                if (subSubContent.length > 0) {
                                                                                    subItem.content = subSubContent;
                                                                                    displaySubContents.push(subItem);
                                                                                }
                                                                            }
                                                                            else {
                                                                                if (!subItem.deleted &&
                                                                                    // !subItem.contract &&
                                                                                    !subItem.expired &&
                                                                                    subItem.data &&
                                                                                    subItem.data.document &&
                                                                                    Array.isArray(subItem.data.document) &&
                                                                                    subItem.data.document.length > 0) {
                                                                                    displaySubContents.push(subItem);
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                                                    finally {
                                                                        try {
                                                                            if (subContents_2_1 && !subContents_2_1.done && (_b = subContents_2.return)) _b.call(subContents_2);
                                                                        }
                                                                        finally { if (e_4) throw e_4.error; }
                                                                    }
                                                                }
                                                                item.content = displaySubContents;
                                                            }
                                                        }
                                                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                                        finally {
                                                            try {
                                                                if (contents_2_1 && !contents_2_1.done && (_a = contents_2.return)) _a.call(contents_2);
                                                            }
                                                            finally { if (e_3) throw e_3.error; }
                                                        }
                                                    }
                                                    // filter empty first level docs
                                                    docs.content = docs.content.filter(function (doc) {
                                                        return doc.content && doc.content.length > 0;
                                                    });
                                                }
                                                return title === section_2;
                                            });
                                        }
                                    }
                                }, function (err) {
                                    //
                                }));
                            }
                        });
                    }
                    else {
                        _this.toastrService.error(res.message);
                    }
                }, function (err) {
                    // if we came here users with given userId do not exist
                }));
            }
        }
        if (this.isDoc) {
            var _c = this.activatedRoute.snapshot.params, documentId = _c.documentId, doc_1 = _c.doc, type = _c.type, key = _c.key, subdocid_1 = _c.subdocid;
            this.documentId = documentId;
            this.subscriptions.push(this.documentArchivesService.getQrcode(this.documentId).subscribe(function (res) {
                if (res.status) {
                    _this.documentArchive = res.data;
                    _this.propertyId = res.data.property;
                    _this.companyId = res.data.companyId;
                    _this.condoStructuresService
                        .getQrcode(res.data.structureId)
                        .subscribe(function (res) {
                        if (res.status) {
                            _this.condoStructure = res.data;
                            _this.subscriptions.push(_this.settingsService.getDocument().subscribe(function (res) {
                                if (res.status) {
                                    if (res.data &&
                                        Array.isArray(res.data) &&
                                        res.data.length > 0 &&
                                        res.data[0].area &&
                                        Array.isArray(res.data[0].area)) {
                                        _this.documentTemplateId = res.data[0]._id;
                                        _this.documentTemplate = res.data[0].area;
                                        _this.allDocs = _this.documentTypeStructure.getDocumentArchiveData("it", // this.lang, 
                                        _this.documentTemplate, _this.condoStructure, _this.documentArchive, "FULL", // this.subscriptionType,
                                        _this.insertedDocs);
                                        _this.formUserData = true;
                                        _this.initForm();
                                        var subSection_1 = "";
                                        switch (doc_1) {
                                            case "gest-amm-tivo-dipendenti":
                                                subSection_1 = "gestAmmTivoDipendenti";
                                                break;
                                            case "gest-amm-tivo-gestione-dipend":
                                                subSection_1 = "gestAmmTivoGestioneDipend";
                                                break;
                                            case "gest-amm-tivo-gestionali":
                                                subSection_1 = "gestAmmTivoGestionali";
                                                break;
                                            case "gest-amm-tivo-gestione-rifiut":
                                                subSection_1 = "gestAmmTivoGestioneRifiut";
                                                break;
                                            case "gest-amm-tivo-banca":
                                                subSection_1 = "gestAmmTivoBanca";
                                                break;
                                            case "gest-amm-tivo-cause-legali":
                                                subSection_1 = "gestAmmTivoCauseLegali";
                                                break;
                                            case "gest-amm-tivo-sicurezza":
                                                subSection_1 = "gestAmmTivoSicurezza";
                                                break;
                                            case "gest-amm-tivo-assicurazioni":
                                                subSection_1 = "gestAmmTivoAssicurazioni";
                                                break;
                                            case "gest-amm-tivo-valut-fornitori":
                                                subSection_1 = "gestAmmTivoValutFornitori";
                                                break;
                                            case "gest-amm-tivoatto-di-acqven":
                                                subSection_1 = "gestAmmTivoattoDiAcqven";
                                                break;
                                            case "gest-amm-tivovincoli-e-diri":
                                                subSection_1 = "gestAmmTivovincoliEDiri";
                                                break;
                                            case "gest-amm-tivoipoteche":
                                                subSection_1 = "gestAmmTivoipoteche";
                                                break;
                                            case "gest-amm-tivotitolarita":
                                                subSection_1 = "gestAmmTivotitolarita";
                                                break;
                                            case "gest-amm-elaborati-grafici":
                                                subSection_1 = "gestAmmelaboratiGrafici";
                                                break;
                                            case "gest-ammape":
                                                subSection_1 = "gestAmmApe";
                                                break;
                                            case "catasto-catasto-terreni":
                                                subSection_1 = "catastoCatastoTerreni";
                                                break;
                                            case "catasto-catasto-fabbricati":
                                                subSection_1 = "catastoCatastoFabbricati";
                                                break;
                                            case "urbedilurbanisted-edili":
                                                subSection_1 = "urbedilurbanistedEdili";
                                                break;
                                            case "urbedilcondoni":
                                                subSection_1 = "urbedilcondoni";
                                                break;
                                            case "urbedilautorizzazioni":
                                                subSection_1 = "urbedilautorizzazioni";
                                                break;
                                            case "stacking-plan":
                                                subSection_1 = "stackingPlan";
                                                break;
                                            case "reportistica":
                                                subSection_1 = "reportistica";
                                                break;
                                            case "locazione-contrdi-locazione":
                                                subSection_1 = "locazioneContrdiLocazione";
                                                break;
                                            case "contratti":
                                                subSection_1 = "contratti";
                                                break;
                                            case "linea-vita":
                                                subSection_1 = "lineaVita";
                                                break;
                                            case "amianto":
                                                subSection_1 = "amiantoDoc";
                                                break;
                                            case "edile-documenti-di-costruz-":
                                                subSection_1 = "ediledocumentiDiCostruz";
                                                break;
                                            case "edile-murature-rei":
                                                subSection_1 = "edilemuratureRei";
                                                break;
                                            case "edile-porte-rei":
                                                subSection_1 = "edileporteRei";
                                                break;
                                            case "edile-interventi-successivi":
                                                subSection_1 = "edileinterventiSuccessivi";
                                                break;
                                            case "edile-strutture":
                                                subSection_1 = "edilestrutture";
                                                break;
                                            case "edile-rete-fognaria":
                                                subSection_1 = "edilereteFognaria";
                                                break;
                                            case "impelegenerale":
                                                subSection_1 = "impelegenerale";
                                                break;
                                            case "impele-media-tensione":
                                                subSection_1 = "impeleMediaTensione";
                                                break;
                                            case "impele-gruppo-elettrogeno":
                                                subSection_1 = "impeleGruppoElettrogeno";
                                                break;
                                            case "impele-fotovoltaico":
                                                subSection_1 = "impeleFotovoltaico";
                                                break;
                                            case "impelescariche-atmosferiche":
                                                subSection_1 = "impelescaricheAtmosferiche";
                                                break;
                                            case "riscaldrisccentraliz":
                                                subSection_1 = "riscaldrisccentraliz";
                                                break;
                                            case "serbatoio-a-gasolio":
                                                subSection_1 = "serbatoioAGasolio";
                                                break;
                                            case "riscaldgas-metcontatrete":
                                                subSection_1 = "riscaldgasMetcontatrete";
                                                break;
                                            case "riscaldsottostazriscaldamen":
                                                subSection_1 = "riscaldsottostazriscaldamen";
                                                break;
                                            case "riscaldcanne-fumarie-per-ct":
                                                subSection_1 = "riscaldcanneFumariePerCt";
                                                break;
                                            case "riscaldsolare-termico":
                                                subSection_1 = "riscaldsolareTermico";
                                                break;
                                            case "riscaldcentrteleriscaldamen":
                                                subSection_1 = "riscaldcentrteleriscaldamen";
                                                break;
                                            case "risc-geotermico-pozzi":
                                                subSection_1 = "riscGeotermicoPozzi";
                                                break;
                                            case "risc-geotermico-sonde":
                                                subSection_1 = "riscGeotermicoSonde";
                                                break;
                                            case "riscaldsolo-pompe-di-calore":
                                                subSection_1 = "riscaldsoloPompeDiCalore";
                                                break;
                                            case "riscaldcentr-ricev-bsc":
                                                subSection_1 = "riscaldcentrRicevBsc";
                                                break;
                                            case "riscaldimpcondizionamento":
                                                subSection_1 = "riscaldimpcondizionamento";
                                                break;
                                            case "risccanne-fumarie-coll-":
                                                subSection_1 = "risccanneFumarieColl";
                                                break;
                                            case "ascensori-e-montauto-ascensori":
                                                subSection_1 = "ascensoriEMontautoAscensori";
                                                break;
                                            case "ascensori-e-montauto-montauto-":
                                                subSection_1 = "ascensoriEMontautoMontauto";
                                                break;
                                            case "trat-acqua-contatore-acqua":
                                                subSection_1 = "tratAcquaContatoreAcqua";
                                                break;
                                            case "trat-acqua-centrale-idrica":
                                                subSection_1 = "tratAcquaCentraleIdrica";
                                                break;
                                            case "trat-acqua-sott-alim-da-bsc":
                                                subSection_1 = "tratAcquaSottAlimDaBsc";
                                                break;
                                            case "trat-acqua-pomp-sollacqpiov":
                                                subSection_1 = "tratAcquaPompSollacqpiov";
                                                break;
                                            case "trat-acqua-rete-idrica-sanitari":
                                                subSection_1 = "tratAcquaReteIdricaSanitari";
                                                break;
                                            case "imp-elettronici-tv-terrestre":
                                                subSection_1 = "impElettronicitvTerrestre";
                                                break;
                                            case "imp-elettronici-tv-satellitare":
                                                subSection_1 = "impElettronicitvSatellitare";
                                                break;
                                            case "imp-elettronici-automazioni":
                                                subSection_1 = "impElettroniciautomazioni";
                                                break;
                                            case "imp-elettronici-imp-citofonico":
                                                subSection_1 = "impElettroniciimpCitofonico";
                                                break;
                                            case "imp-elettronici-impianto-tvcc":
                                                subSection_1 = "impElettroniciimpiantoTvcc";
                                                break;
                                            case "imp-elettronici-antintrusione":
                                                subSection_1 = "impElettroniciantintrusione";
                                                break;
                                            case "vv-fdefinitivo":
                                                subSection_1 = "vvFdefinitivo";
                                                break;
                                            case "sicurezza-antincendio-facciate":
                                                subSection_1 = "sicurezzaAntincendioFacciate";
                                                break;
                                            case "incendio-estintori-":
                                                subSection_1 = "incendioEstintori";
                                                break;
                                            case "incendio-rete-idranti":
                                                subSection_1 = "incendioReteIdranti";
                                                break;
                                            case "incendio-rete-sprinkler":
                                                subSection_1 = "incendioReteSprinkler";
                                                break;
                                            case "incendio-stazione-pompaggio":
                                                subSection_1 = "incendioStazionePompaggio";
                                                break;
                                            case "incendio-rilevazione":
                                                subSection_1 = "incendioRilevazione";
                                                break;
                                            case "incendio-ventilazione":
                                                subSection_1 = "incendioVentilazione";
                                                break;
                                            case "incendio-evac":
                                                subSection_1 = "incendioEvac";
                                                break;
                                            case "impianti-speciali":
                                                subSection_1 = "impiantiSpeciali";
                                                break;
                                            case "impricreativi-piscina":
                                                subSection_1 = "impricreativipiscina";
                                                break;
                                            case "impricreativi-palestra":
                                                subSection_1 = "impricreativipalestra";
                                                break;
                                            case "impricreativi-campo-tennis":
                                                subSection_1 = "impricreativicampoTennis";
                                                break;
                                            case "impricreativi-campo-calcio":
                                                subSection_1 = "impricreativicampoCalcio";
                                                break;
                                            case "impricreativi-parco-giochi":
                                                subSection_1 = "impricreativiparcoGiochi";
                                                break;
                                            case "unitaimmvvf":
                                                subSection_1 = "unitaimmvvf";
                                                break;
                                            case "unita-immdoc-amm-":
                                                subSection_1 = "unitaImmdocAmm";
                                                break;
                                            case "unitaimmelettrico":
                                                subSection_1 = "unitaimmelettrico";
                                                break;
                                            case "unitaimmantintrusione":
                                                subSection_1 = "unitaimmantintrusione";
                                                break;
                                            case "unitaimmidrico-sanitari":
                                                subSection_1 = "unitaimmidricoSanitari";
                                                break;
                                            case "unitaimmtermico":
                                                subSection_1 = "unitaimmtermico";
                                                break;
                                            case "unitaimmcondizionamento":
                                                subSection_1 = "unitaimmcondizionamento";
                                                break;
                                            case "unitaimmape":
                                                subSection_1 = "unitaimmape";
                                                break;
                                            case "unitaimmelaborati-grafici":
                                                subSection_1 = "unitaimmelaboratiGrafici";
                                                break;
                                            case "unitaimmcanne-fumarie-per-":
                                                subSection_1 = "unitaimmcanneFumariePer";
                                                break;
                                            case "unita-immsicurezza":
                                                subSection_1 = "unitaImmsicurezza";
                                                break;
                                            default:
                                                subSection_1 = doc_1;
                                        }
                                        _this.displayedDocs = _this.allDocs.filter(function (docs) {
                                            var e_5, _a, e_6, _b, e_7, _c;
                                            var contents = docs.content;
                                            if (contents && Array.isArray(contents)) {
                                                try {
                                                    for (var contents_3 = tslib_1.__values(contents), contents_3_1 = contents_3.next(); !contents_3_1.done; contents_3_1 = contents_3.next()) {
                                                        var item = contents_3_1.value;
                                                        if (item && item.keyTranslateTitle) {
                                                            var title = item.keyTranslateTitle.replace("properties.documents.", "");
                                                            // filter missing docs and deleted structure
                                                            if (title === subSection_1) {
                                                                var subContents = item.content;
                                                                var displaySubContents = [];
                                                                if (subContents && Array.isArray(subContents)) {
                                                                    try {
                                                                        for (var subContents_3 = (e_6 = void 0, tslib_1.__values(subContents)), subContents_3_1 = subContents_3.next(); !subContents_3_1.done; subContents_3_1 = subContents_3.next()) {
                                                                            var subItem = subContents_3_1.value;
                                                                            if ((subItem.structureId && subItem.structureId !== "") ||
                                                                                subSection_1 === 'edileinterventiSuccessivi' ||
                                                                                subSection_1 === 'gestAmmTivoCauseLegali' ||
                                                                                subSection_1 === 'gestAmmTivoValutFornitori' ||
                                                                                subSection_1 === 'locazioneContrdiLocazione') {
                                                                                if (subItem.active ||
                                                                                    subSection_1 === 'edileinterventiSuccessivi' ||
                                                                                    subSection_1 === 'gestAmmTivoCauseLegali' ||
                                                                                    subSection_1 === 'gestAmmTivoValutFornitori' ||
                                                                                    subSection_1 === 'locazioneContrdiLocazione') {
                                                                                    var subSubContent = subItem.content;
                                                                                    if (subSubContent && Array.isArray(subSubContent)) {
                                                                                        subSubContent = subSubContent.filter(function (subSubItem) {
                                                                                            return subSubItem.docId.toString() === subdocid_1 &&
                                                                                                !subSubItem.deleted &&
                                                                                                // !subSubItem.contract &&
                                                                                                !subSubItem.expired &&
                                                                                                subSubItem.data &&
                                                                                                subSubItem.data.document &&
                                                                                                Array.isArray(subSubItem.data.document) &&
                                                                                                subSubItem.data.document.length > 0;
                                                                                        });
                                                                                    }
                                                                                    if (subSubContent.length > 0) {
                                                                                        subItem.content = subSubContent;
                                                                                        displaySubContents.push(subItem);
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                if (subItem &&
                                                                                    subItem.docId &&
                                                                                    subItem.docId.toString() === subdocid_1 &&
                                                                                    !subItem.deleted &&
                                                                                    // !subItem.contract &&
                                                                                    !subItem.expired &&
                                                                                    subItem.data &&
                                                                                    subItem.data.document &&
                                                                                    Array.isArray(subItem.data.document) &&
                                                                                    subItem.data.document.length > 0) {
                                                                                    displaySubContents.push(subItem);
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                                                                    finally {
                                                                        try {
                                                                            if (subContents_3_1 && !subContents_3_1.done && (_b = subContents_3.return)) _b.call(subContents_3);
                                                                        }
                                                                        finally { if (e_6) throw e_6.error; }
                                                                    }
                                                                }
                                                                item.content = displaySubContents;
                                                            }
                                                            else {
                                                                item.content = [];
                                                            }
                                                        }
                                                        else {
                                                            // unità immobiliari
                                                            var subContents = item.content;
                                                            var displaySubContents = [];
                                                            if (subContents && Array.isArray(subContents)) {
                                                                try {
                                                                    for (var subContents_4 = (e_7 = void 0, tslib_1.__values(subContents)), subContents_4_1 = subContents_4.next(); !subContents_4_1.done; subContents_4_1 = subContents_4.next()) {
                                                                        var subItem = subContents_4_1.value;
                                                                        var title = subItem.keyTranslateTitle.replace("properties.documents.", "");
                                                                        // filter missing docs and deleted structure
                                                                        if (title === subSection_1) {
                                                                            if (subItem.structureId && subItem.structureId !== "") {
                                                                                if (subItem.active) {
                                                                                    var subSubContent = subItem.content;
                                                                                    if (subSubContent && Array.isArray(subSubContent)) {
                                                                                        subSubContent = subSubContent.filter(function (subSubItem) {
                                                                                            return subSubItem.docId.toString() === subdocid_1 &&
                                                                                                !subSubItem.deleted &&
                                                                                                // !subSubItem.contract &&
                                                                                                !subSubItem.expired &&
                                                                                                subSubItem.data &&
                                                                                                subSubItem.data.document &&
                                                                                                Array.isArray(subSubItem.data.document) &&
                                                                                                subSubItem.data.document.length > 0;
                                                                                        });
                                                                                    }
                                                                                    if (subSubContent.length > 0) {
                                                                                        subItem.content = subSubContent;
                                                                                        displaySubContents.push(subItem);
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                if (subItem &&
                                                                                    subItem.docId &&
                                                                                    subItem.docId.toString() === subdocid_1 &&
                                                                                    !subItem.deleted &&
                                                                                    // !subItem.contract &&
                                                                                    !subItem.expired &&
                                                                                    subItem.data &&
                                                                                    subItem.data.document &&
                                                                                    Array.isArray(subItem.data.document) &&
                                                                                    subItem.data.document.length > 0) {
                                                                                    displaySubContents.push(subItem);
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                                                                finally {
                                                                    try {
                                                                        if (subContents_4_1 && !subContents_4_1.done && (_c = subContents_4.return)) _c.call(subContents_4);
                                                                    }
                                                                    finally { if (e_7) throw e_7.error; }
                                                                }
                                                            }
                                                            item.content = displaySubContents;
                                                        }
                                                    }
                                                }
                                                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                                                finally {
                                                    try {
                                                        if (contents_3_1 && !contents_3_1.done && (_a = contents_3.return)) _a.call(contents_3);
                                                    }
                                                    finally { if (e_5) throw e_5.error; }
                                                }
                                            }
                                            // filter empty first level docs
                                            docs.content = docs.content.filter(function (doc) {
                                                return doc.content && doc.content.length > 0;
                                            });
                                            // }
                                            // return title === section;
                                            return docs.content.length > 0;
                                        });
                                    }
                                }
                            }, function (err) {
                                //
                            }));
                        }
                    });
                }
                else {
                    _this.toastrService.error(res.message);
                }
            }, function (err) {
                // if we came here users with given userId do not exist
            }));
        }
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PublicQRCodeComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    PublicQRCodeComponent.prototype.initForm = function () {
        // Set model
        this.model = {
            firstName: this.firstName,
            lastName: this.lastName,
            company: this.companyName,
        };
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        type: "input",
                        key: "firstName",
                        templateOptions: {
                            label: this.translateService.instant("qrcode.viewPage.form.firstName.label"),
                            placeholder: this.translateService.instant("qrcode.viewPage.form.firstName.placeholder"),
                            required: true,
                            maxLength: 320,
                        },
                        defaultValue: this.firstName,
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "lastName",
                        templateOptions: {
                            label: this.translateService.instant("qrcode.viewPage.form.lastName.label"),
                            placeholder: this.translateService.instant("qrcode.viewPage.form.lastName.placeholder"),
                            required: true,
                            maxLength: 320,
                        },
                        defaultValue: this.lastName,
                    },
                    {
                        className: "col-12",
                        type: "input",
                        key: "company",
                        templateOptions: {
                            label: this.translateService.instant("qrcode.viewPage.form.company.label"),
                            placeholder: this.translateService.instant("qrcode.viewPage.form.company.placeholder"),
                            required: false,
                            maxLength: 320,
                        },
                        defaultValue: this.companyName,
                    },
                ],
            },
        ];
        if (this.forceSubmit) {
            this.onFormSubmit(this.model);
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    PublicQRCodeComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            return;
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        if (this.isVideo) {
            // const params = {
            //   firstName: model.firstName,
            //   lastName: model.lastName,
            //   company: model.company,
            // };
            // this.subscriptions.push(
            //   this.propertiesService
            //     .setVideoVisit(this.propertyId, params)
            //     .pipe(finalize(() => (this.formBtnOptions.active = false)))
            //     .subscribe(
            //       (res) => {
            //         if (res.status) {
            //           this.formUserData = false;
            //           this.showVideo = true;
            //           return;
            //         }
            //       },
            //       (err) => {
            //         // Choose one of the following error handling method.
            //         // 1) First one show a message right under the form fields
            //         //    (if the form is properly setted)
            //         // 2) Second one is used to show a mat-error under each field
            //         //    in the dynamic form (is meant to be used only in dynamicForm)
            //         // 3) Third one show toastr notifications for each error
            //         // 4) Fourth one is used to show mat-error under each field
            //         //    in the ngx-formly form (is mean to be used only with ngx-formly)
            //         // this.helperService.handleFormError(form, err);
            //         // this.helperService.handleDynamicFormError(form, err);
            //         // this.helperService.handleError(err);
            //         this.helperService.handleFormlyError(this.form, err);
            //       }
            //     )
            // );
            this.formUserData = false;
            this.showVideo = true;
        }
        if (this.isSafetyVideoResidents || this.isSafetyVideoSuppliers) {
            var params = {
                companyId: this.companyId,
                type: this.isSafetyVideoResidents ? 'resident' : 'supplier',
                firstName: model.firstName,
                lastName: model.lastName,
                companyName: model.company,
            };
            this.subscriptions.push(this.videoViewService
                .create(params)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                if (res.status) {
                    _this.formUserData = false;
                    if (_this.isSafetyVideoResidents) {
                        _this.showVideoResident = true;
                    }
                    else if (_this.isSafetyVideoSuppliers) {
                        _this.showVideoSupplier = true;
                    }
                    return;
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                // this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        }
        if (this.isDoc || this.isDocsSection) {
            this.subscriptions.push(this.accessLogsService
                .Qrcode("external", "web", model.firstName, model.lastName, model.company, this.companyId)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                if (res.status) {
                    _this.formUserData = false;
                    if (_this.isDoc) {
                        _this.showDoc = true;
                    }
                    if (_this.isDocsSection) {
                        _this.showDocSection = true;
                    }
                    return;
                }
            }, function (err) {
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        }
    };
    /**
     * Utility: extracts documents from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    PublicQRCodeComponent.prototype.getDocsFromSection = function (section) {
        var _this = this;
        var docList = [];
        var _loop_1 = function (doc) {
            if (section.documents[doc].length) {
                section.documents[doc].forEach(function (item) {
                    if (!item.deleted && item.data /* && !item.contract */ && !item.expired) {
                        docList.push({
                            title: _this.translateService.instant("properties.documents.titles." + doc),
                            type: "doc",
                            docId: item._id,
                            key: doc,
                            mandatory: item.mandatory,
                            expired: item.expired,
                            deleted: item.deleted,
                            dateExpired: item.dateExpired,
                            contract: item.contract,
                            pdfmsg: item.pdfmsg,
                            data: item.data,
                            checked: false,
                        });
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_1(doc);
        }
        // docList.sort(this.compareExpired);
        return docList;
    };
    /**
     * Utility: extracts single document from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    PublicQRCodeComponent.prototype.getSingleDocFromSection = function (section, type, key, subdocId) {
        var _this = this;
        var docList = [];
        var _loop_2 = function (doc) {
            if (doc === key) {
                if (section.documents[doc].length) {
                    section.documents[doc].forEach(function (item) {
                        if (item._id.toString() === subdocId.toString()) {
                            if (!item.deleted &&
                                item.data &&
                                // !item.contract &&
                                !item.expired) {
                                docList.push({
                                    title: _this.translateService.instant("properties.documents.titles." + doc),
                                    type: "doc",
                                    docId: item._id,
                                    key: doc,
                                    mandatory: item.mandatory,
                                    expired: item.expired,
                                    deleted: item.deleted,
                                    dateExpired: item.dateExpired,
                                    contract: item.contract,
                                    pdfmsg: item.pdfmsg,
                                    data: item.data,
                                    checked: false,
                                });
                            }
                        }
                    });
                }
            }
        };
        for (var doc in section.documents) {
            _loop_2(doc);
        }
        // docList.sort(this.compareExpired);
        return docList;
    };
    /**
     * Handle click on document form to download file
     * itemData: data value of form items
     *
     * @since 1.0.0
     */
    PublicQRCodeComponent.prototype.onToggleDownloadDocument = function (documents) {
        if (!documents || !documents.length) {
            console.warn("ERROR: NO DOCS");
            return;
        }
        var dialogRef = this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                propertyId: this.propertyId,
                documents: documents,
            },
            width: "600px",
        });
    };
    /**
     * Handle table sort
     *
     * @since 1.0.0
     */
    PublicQRCodeComponent.prototype.sortData = function (sort, i, t, x, pos) {
        var _this = this;
        var sortedData = [];
        if (pos === "1") {
            sortedData = this.displayedDocs[i].content[t].content[x].content;
        }
        else if (pos === "2") {
            sortedData = this.displayedDocs[i].content[t].content;
        }
        else if (pos === "3") {
            sortedData = this.displayedDocs[i].content;
        }
        if (!this.sortActive) {
            this.currentOriginalOrder = JSON.parse(JSON.stringify(sortedData));
        }
        var data = sortedData;
        if (!sort.active || sort.direction === "") {
            sortedData = this.currentOriginalOrder;
            if (pos === "1") {
                this.displayedDocs[i].content[t].content[x].content = sortedData;
            }
            else if (pos === "2") {
                this.displayedDocs[i].content[t].content = sortedData;
            }
            else if (pos === "3") {
                this.displayedDocs[i].content = sortedData;
            }
            this.sortActive = false;
            return;
        }
        sortedData = data.sort(function (a, b) {
            var isAsc = sort.direction === "asc";
            switch (sort.active) {
                case "title":
                    return _this.compare(a.title.toLowerCase(), b.title.toLowerCase(), isAsc);
                case "data.contenutoDocumento":
                    var aContenutoDocumento = a.data && a.data.contenutoDocumento
                        ? a.data.contenutoDocumento.toLowerCase()
                        : "";
                    var bContenutoDocumento = b.data && b.data.contenutoDocumento
                        ? b.data.contenutoDocumento.toLowerCase()
                        : "";
                    return _this.compare(aContenutoDocumento, bContenutoDocumento, isAsc);
                case "data.ragioneSocialeFornitore":
                    var aRagioneSocialeFornitore = a.data && a.data.ragioneSocialeFornitore
                        ? a.data.ragioneSocialeFornitore
                        : "";
                    var bRagioneSocialeFornitore = b.data && b.data.ragioneSocialeFornitore
                        ? b.data.ragioneSocialeFornitore
                        : "";
                    return _this.compare(aRagioneSocialeFornitore, bRagioneSocialeFornitore, isAsc);
                case "data.dataDocumento":
                    var aDataDocumento = a.data && a.data.dataDocumento ? a.data.dataDocumento : "";
                    var bDataDocumento = b.data && b.data.dataDocumento ? b.data.dataDocumento : "";
                    return _this.compare(aDataDocumento, bDataDocumento, isAsc);
                case "dateExpired":
                    var aDateExpired = a.dateExpired ? a.dateExpired : "";
                    var bDateExpired = b.dateExpired ? b.dateExpired : "";
                    return _this.compare(aDateExpired, bDateExpired, isAsc);
                default:
                    return 0;
            }
        });
        if (pos === "1") {
            this.displayedDocs[i].content[t].content[x].content = sortedData;
        }
        else if (pos === "2") {
            this.displayedDocs[i].content[t].content = sortedData;
        }
        else if (pos === "3") {
            this.displayedDocs[i].content = sortedData;
        }
        this.sortActive = true;
    };
    /**
     * Utility per table sort
     *
     * @since 1.0.0
     */
    PublicQRCodeComponent.prototype.compare = function (a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    return PublicQRCodeComponent;
}());
export { PublicQRCodeComponent };
